import { Component, type ErrorInfo, type ReactNode } from "react";

/** Last-resort boundary: an unexpected render error shows a recoverable message instead of a blank page. */
export class ErrorBoundary extends Component<{ children: ReactNode }, { failed: boolean }> {
  override state = { failed: false };

  static getDerivedStateFromError() {
    return { failed: true };
  }

  override componentDidCatch(error: Error, info: ErrorInfo) {
    console.error("Unhandled UI error", error, info.componentStack);
  }

  override render() {
    if (!this.state.failed) return this.props.children;
    return (
      <div className="center-page">
        <div className="auth-card" role="alert">
          <h1 className="h1">Ceva nu a funcționat</h1>
          <p className="muted" style={{ margin: 0 }}>
            Pagina a întâmpinat o eroare neașteptată. Datele tale salvate nu sunt afectate.
          </p>
          <button type="button" className="btn btn-primary" onClick={() => window.location.reload()}>
            Reîncarcă pagina
          </button>
        </div>
      </div>
    );
  }
}
